import React, { useEffect, useState, useRef } from "react";
import "./labelAuditComponent.css";
import SupplierSelectComponent from "../supplier-select-component/SupplierSelectComponent";
import { useOktaAuth } from "@okta/okta-react";
import ResultsTable from "../label-results/ResultsTable";
import ResultsAccordion from "../label-results/ResultsAccordion";
import axios from "axios";
import SaveIcon from "@mui/icons-material/Save";
import ModalComponent from "../modal-component/ModalComponent";
import Alert from "@mui/material/Alert";
import { FileInput } from "@deere/fuel-react/FileInput";
import {FileList} from '@deere/fuel-react/FileList';
import {FileListItem} from '@deere/fuel-react/FileListItem';
import {FileValidationList} from '@deere/fuel-react/FileValidationList';
import {FileValidationListItem} from '@deere/fuel-react/FileValidationListItem';
import {
  Typography,
  Box,
  CircularProgress,
  Button,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { useUserDetails } from "../../hooks";

const LabelAuditComponent = (props) => {
  const { oktaAuth } = useOktaAuth();
  const {
    invalidFileName,
    invalidFileType,
    setInvalidFileType,
    setInvalidFileName,
    usertype,
    setShowInvalidlabel,
    setTimeAlert,
    setProcessingTime,
    processingTime,
    setInvalidLabelType,
    setSystemError,
    useremail,
    refreshHandler,
    setlabelIsNotValid,
    userid,
  } = props;
  const [supplierNumber, setSupplierNumber] = useState(null);
  const [allFieldsSelected, setAllFieldsSelected] = useState(false);
  const [supplierName, setSupplierName] = useState(null);
  const [requestIsSuccessful, setRequestIsSuccessful] = useState(false);
  const [file, setFile] = useState(null);
  const [reviewStatus, setReviewStatus] = useState(null);
  const [noOf1dFailed, setNoOf1dFailed] = useState(0);
  const [noOf1dSuccess, setNoOf1dSuccess] = useState(0);
  const [noOf2dFailed, setNoOf2dFailed] = useState(0);
  const [noOf2dSuccess, setNoOf2dSuccess] = useState(0);
  const [noOfOcrFailed, setNoOfOcrFailed] = useState(0);
  const [noOfOcrSuccess, setNoOfOcrSuccess] = useState(0);
  const [response, setResponse] = useState();
  const [isLoading, setisLoading] = useState();
  const [resultFileName, setResultFileName] = useState(null);
  const [count, setCount] = useState(0);
  const [lastTestedDate, setLastTestedDate] = useState(null);
  const [isHide, setIsHide] = useState(true);
  const fileRef = useRef(null);
  const [seconds, setSeconds] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [dataLabelError, setDataLabelError] = useState(false);
  const { oktaDetails, setSupplierList, supplierList } = useUserDetails();
  const ref = useRef();
    const validateFile = (file) => {
    const isValidExtension = file.name.endsWith('.pdf') || file.name.endsWith('.png') || file.name.endsWith('.jpg') || file.name.endsWith('.bpm');
    setInvalidFileType(!isValidExtension);



    if (isValidExtension) {
      setFile(file);
      getProcessingTime(file);
    } else {
      setFile(null);
      setAllFieldsSelected(false)
    }
  };

  const searchSuppliers = (e) => {
    //for John Deere internal Employee, needs to submit atleast 4 digits
    if (e.target.value.length >= 3) {
      oktaDetails.usertype !== "Supplier Employee" &&
        axios
          .get(
            process.env.REACT_APP_API_BASE_URL +
              "/getSupplierInfoEmployee?queryString=" +
              e.target.value,
            {
              params: {
                _limit: 5,
              },
              headers: {
                Authorization: "Bearer " + oktaAuth.getAccessToken(),
              },
            }
          )
          .then((response) => {
            const filteredResponse = response.data.map(
              (item) => item.supplierNumber + " - " + item.supplierName
            );
            setSupplierList(filteredResponse);
          })
          .catch((error) => {
            setSystemError(true);
          });
    }
  };

  const supplierChangeHandler = (event) => {
    if (!event || !supplierList.includes(event)) {
      setSupplierNumber(null);
      setSupplierName(null);
    setAllFieldsSelected(false)
  } else {
      setSupplierNumber(event.slice(0, 10));
      setSupplierName(event.slice(13));
  }
  };

  const refreshHandler1 = () => {
    setShowModal(false);
    window.location.reload();
  };

  const onFileChange = (files) => {
    //accept only if .pdf, .jpg, .png, .bmp
    if (
      !(
        files[0].name.endsWith(".pdf") ||
        files[0].name.endsWith(".PDF") ||
        files[0].name.endsWith(".jpg") ||
        files[0].name.endsWith(".jpg") ||
        files[0].name.endsWith(".png") ||
        files[0].name.endsWith(".bmp")
      )
    ) {
      setFile(() => null);
      fileRef.current.value = "";
      setInvalidLabelType(true);
      setTimeAlert(false);
    }
    //when no file
    else if (typeof files[0] === "undefined") {
      setFile(null);
      setTimeAlert(false);
    } else {
      setInvalidLabelType(false);
      setFile(files[0]);
      getProcessingTime(files[0]);
      setTimeAlert(true);
    }
  };
const downloadReport = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/downloadLabelfilefroms3/`,
      {
        params: {
          fileName: resultFileName,
        },
        headers: {
          Authorization: "Bearer " + oktaAuth.getAccessToken(),
        },
        responseType: "blob", // importante para manejar archivos
      }
    );

    const element = document.createElement("a");
    const newFile = new Blob([response.data], { type: "text/html" });
    element.href = URL.createObjectURL(newFile);
    element.download = resultFileName;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  } catch (error) {
    console.error("Error al descargar el archivo:", error);

  }
};


  useEffect(() => {
    //finds the count of all tests and recent test date
    if (supplierNumber && file) {
      setAllFieldsSelected(true);
    }
    const formData = new FormData();
    supplierNumber && formData.append("supplierId", supplierNumber);

    supplierNumber &&
      axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/getNumberOfTimesTestedLabel",
          formData,
          {
            headers: {
              Authorization: "Bearer " + oktaAuth.getAccessToken(),
            },
          }
        )
        .then(
          (response) => {
            const timestamp = new Date(response.data[0].max);
            setLastTestedDate(timestamp.toString());
            setCount(response.data[0].count);
          },
          (error) => {
            setSystemError(true);
          }
        );
  }, [
    supplierNumber,
    setSupplierNumber,
    file,
    setFile,
    oktaAuth,
    setSystemError,
  ]);

  const downloadSubmittedFile = () => {
    const element = document.createElement("a");
    const newFile = new Blob([file], { type: ".pdf/.png/.jpg/.bmp" });
    element.href = URL.createObjectURL(newFile);
    element.download = file.name;
    document.body.appendChild(element);
    element.click();
  };

  //to get the processing time for uploaded file
  async function getProcessingTime(fileData) {
    const fileformData = new FormData();
    fileformData.append("file", fileData);

    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + "/getProcessingTimeForLabel",
        fileformData,
        {
          headers: {
            Authorization: "Bearer " + oktaAuth.getAccessToken(),
          },
        }
      )
      .then((response) => {
        let temp = response.data.ProccessingTime;
        setProcessingTime(temp);
      })
      .catch((error) => {
        setSystemError(true);
        setTimeAlert(false);
      });
  }
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (isLoading) {
        setSeconds((seconds) => seconds + 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [isLoading]);

  const updateLabel = async () => {
    setShowModal(false);
    setTimeAlert(false);

    //file,supplierId, email, supplierName, jwtToken, userId append;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("supplierId", supplierNumber);
    formData.append("supplierName", supplierName);
    formData.append("email", useremail);
    formData.append("jwtToken", oktaAuth.getAccessToken());
    formData.append("userId", userid);
    await axios
      .post(process.env.REACT_APP_API_BASE_URL + "/labels", formData, {
        headers: {
          Authorization: "Bearer " + oktaAuth.getAccessToken(),
        },
      })
      .then(
        (res) => {
          setisLoading(false);
          const downloadresponse = res.data;
          const responseData = res.data.result;
          console.log(responseData)
          if (responseData.readings.hasOwnProperty("label1DNotValid")) {
            setShowInvalidlabel(true);
            setlabelIsNotValid(responseData.readings.label1DNotValid);
          } else {
            setResponse(responseData);
            let noOf1dFailedTemp = 0;
            let noOf2dFailedTemp = 0;
            let noOf1dSuccessTemp = 0;
            let noOf2dSuccessTemp = 0;
            let noOfOcrSuccessTemp = 0;
            let noOfOcrFailedTemp = 0;
            for (
              let i = 0;
              i < Object.keys(responseData.readings).length;
              i++
            ) {
              if (
                responseData.readings[i].lpn_1d_validations.status === "ERR"
              ) {
                noOf1dFailedTemp = noOf1dFailedTemp + 1;
              } else if (
                responseData.readings[i].lpn_1d_validations.status === "OK"
              ) {
                noOf1dSuccessTemp = noOf1dSuccessTemp + 1;
              }
              if (
                responseData.readings[i].lpn_2d_validations.status === "ERR"
              ) {
                noOf2dFailedTemp = noOf2dFailedTemp + 1;
              } else if (
                responseData.readings[i].lpn_2d_validations.status === "OK"
              ) {
                noOf2dSuccessTemp = noOf2dSuccessTemp + 1;
              }
              if (responseData.readings[i].ocrStatus === "ERR") {
                noOfOcrFailedTemp = noOfOcrFailedTemp + 1;
              } else if (responseData.readings[i].ocrStatus === "OK") {
                noOfOcrSuccessTemp = noOfOcrSuccessTemp + 1;
              }
              //to check test is complaint or not
              const status =
                responseData.readings[i].lpn_1d_validations.status === "ERR" ||
                responseData.readings[i].lpn_2d_validations.status === "ERR";
              let index = downloadresponse.htmlfileurl.lastIndexOf("/") + 1;
              let tempFileName =
                supplierNumber +
                "/" +
                downloadresponse.htmlfileurl.slice(index);
              setResultFileName(tempFileName);
              setReviewStatus(reviewStatus || status);
            }
            setNoOf1dFailed(noOf1dFailedTemp);
            setNoOf1dSuccess(noOf1dSuccessTemp);
            setNoOf2dFailed(noOf2dFailedTemp);
            setNoOf2dSuccess(noOf2dSuccessTemp);
            setNoOfOcrFailed(noOfOcrFailedTemp);
            setNoOfOcrSuccess(noOfOcrSuccessTemp);
            setRequestIsSuccessful(true);
          }
        },
        (error) => {
          setDataLabelError(true);
          setisLoading(false);
          setSystemError(false);
        }
      );
  };

  async function submitLabel() {
    if (processingTime <= 60) {
      setisLoading(true);
      setIsHide(false);
      updateLabel();
    } else {
      setShowModal(true);
    }
  }

  return (
    <>
      {requestIsSuccessful ? (
        <div>
          <Card className="p-4">
            {reviewStatus === true ? (
              <Alert severity="error">
                <Typography variant="button" display="block" gutterBottom>
                  {" "}
                  {"Not Compliant with Global Guidelines "}
                  <Button onClick={downloadReport} startIcon={<SaveIcon />}>
                    Download Errors
                  </Button>
                </Typography>
              </Alert>
            ) : (
              <Alert severity="success">
                <Typography variant="button" display="block" gutterBottom>
                  Compliant with Label Guidelines
                </Typography>
              </Alert>
            )}
            <br />
            <Grid className="grid-example" container>
              <Grid item sm={6} xs={12}>
                <Box p={4}>
                  <b>John Deere Supplier Number </b>
                  <br />
                  {supplierName ? (
                    <Typography size="sm">
                      {supplierNumber} - {supplierName}
                    </Typography>
                  ) : (
                    <Typography size="sm">{supplierNumber}</Typography>
                  )}
                </Box>
              </Grid>
              <Grid item sm={6} xs={12}>
                <Box p={4}>
                  <b>Submitted Label</b> <br />
                  <Button variant="text" onClick={downloadSubmittedFile}>
                    {file.name}
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <br /> <br />
            <ResultsTable
              noOf1dFailed={noOf1dFailed}
              noOf1dSuccess={noOf1dSuccess}
              noOf2dFailed={noOf2dFailed}
              noOf2dSuccess={noOf2dSuccess}
              noOfOcrFailed={noOfOcrFailed}
              noOfOcrSuccess={noOfOcrSuccess}
            />
            <br />
            <ResultsAccordion readings={response?.readings} />
            <br />
            <div className="newTestbtn">
              <Button variant="primary" onClick={refreshHandler}>
                Start New Test
              </Button>
            </div>
          </Card>
        </div>
      ) : (
        <div>
          {isLoading && (
            <div>
              <>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Box px={1} width="100%">
                    <Box
                      alignItems="center"
                      display="flex"
                      flexDirection="column"
                      height={200}
                      justifyContent="center"
                      p={4}
                    >
                      <CircularProgress />
                      <Typography size="xl" component="p" gutterBottom>
                        {"Testing Label Compliance"}
                      </Typography>
                      <Typography size="md" component="p" gutterBottom>
                        {"This will take about"} {processingTime}{" "}
                        {
                          " seconds. You may navigate away and the results will be emailed to you."
                        }
                      </Typography>
                      <Typography size="sm" component="p" gutterBottom>
                        {"Time elapsed: "} <b>{seconds}</b> {" seconds"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </>
            </div>
          )}
          {isHide && (
            <Card className="p-3">
              <CardContent>
                <p className="entryLabel">John Deere Supplier Number</p>
                <Grid container spacing={2}>
                  <Grid item xs={4} sm={4} md={8} lg={8} xl={8}>
                    <div className="row">
                      <div className="col LabelSelectComponentAliginement">
                        <SupplierSelectComponent
                          userType={usertype}
                          supplierList={supplierList}
                          supplierChangeHandler={supplierChangeHandler}
                          handleKeyDown={searchSuppliers}
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
                {supplierNumber ? (
                  <Alert
                    className="alert-label"
                    variant="info"
                    sx={{ width: "41%" }}
                  >
                    <Typography variant="button" display="block" gutterBottom>
                      {"Tested"} {count} {"Previous Times"}
                    </Typography>
                    {count === 0 ? null : (
                      <>
                        <Typography
                          variant="button"
                          display="block"
                          gutterBottom
                        >
                          {"Last tested on"} {lastTestedDate}
                        </Typography>
                      </>
                    )}
                  </Alert>
                ) : null}
                <p className="entryLabel">
                  Label to Test{" "}
                  <span className="textFormat">
                    (.jpg, .png, .pdf, .bmp format required)
                  </span>
                </p>
                <div className="fieldSize">
              <FileInput
              id="file-input"
              name="file-input"
              ref={ref}
              inputProps={{ accept: '.pdf,.png,.jpg,.bmp' }}
              onChange={(event) => {
                      const files = event.target.files;
                      
                      if (files && files.length > 0) {
                        validateFile(files[0]); 
                      } else {
                        setFile(null);
                      }
                    }}
              renderFileList={(fileList) => (
                                    <FileList>
                                      {fileList?.map((file) => (
                                        <FileListItem
                                          key={file.name}
                                          text={file.name}
                                          validationState={
                                            invalidFileType ? 'invalid' : 'valid'
                                          }
                                        />
                                      ))}
                                    </FileList>
                                  )}
              renderValidations={() => (
                <>
                  <Typography component="div" variant="labelMedium">
                    File Format
                  </Typography>
                  <FileValidationList>
                    <FileValidationListItem
                      text="File Type (.pdf, .png, .jpg, .bmp)"
                      state={invalidFileType ? 'invalid' : 'valid'}
                    />
                  </FileValidationList>
                </>
              )}
            />
                </div>
                <br />
                <div>
                  <Button
                    variant="primary"
                    disabled={!allFieldsSelected}
                    onClick={submitLabel}
                  >
                    Submit Label For Review
                  </Button>
                </div>
              </CardContent>
            </Card>
          )}
          {dataLabelError && (
            <div>
              <Card className="p-3">
                <Typography
                  variant="text"
                  display="block"
                  gutterBottom
                  className="LabelDataError"
                >
                  Something Went Wrong. Please Contact Administrator.
                </Typography>
              </Card>
            </div>
          )}
        </div>
      )}
      <ModalComponent
        show={showModal}
        processingTime={processingTime}
        useremail={useremail}
        time={60}
        refreshHandler={refreshHandler1}
        cancelModal={updateLabel}
      />
    </>
  );
};

export default LabelAuditComponent;
